<template>
  <section class="photos-slider">
    <div class="" :class="{'photos-slider-grid , bg-color-theme2': this.iconNum === 1 ,
     'photos-slider-grid2 , bg-color-theme': this.iconNum === 2}">
      <div class="photos-slider-head mt-5" >
        <div class="text-center">
          <svg v-if="this.iconNum === 1" class="icon" width="50" height="50">
            <use href="@/assets/svgIcons/svgIcons.svg/#gallery"></use>
          </svg>
          <svg v-else-if="this.iconNum === 2" class="icon" width="50" height="50">
            <use href="@/assets/svgIcons/svgIcons.svg/#video"></use>
          </svg>
        </div>
        <h6 class="fontsize-xheavy text-center my-xl-5 my-4"> {{this.title}}</h6>
        <div class="text-center"><router-link to="/photos?type=main">مشاهده همه</router-link></div>
      </div>
      <div class="photos-slider-content">
        <div class="d-md-none head2 d-flex flex-column justify-content-center align-items-center">
          <div v-if="this.iconNum === 1" class="text-center"><svg class="icon" width="30" height="30"><use href="@/assets/svgIcons/svgIcons.svg/#gallery2"></use></svg></div>
          <div v-else-if="this.iconNum === 2" class="text-center"><svg class="icon" width="30" height="30"><use href="@/assets/svgIcons/svgIcons.svg/#video2"></use></svg></div>
          <div class="text-center mt-4"><span class="text-white fontsize-large">
            <router-link style="color:white;" to="/photos?type=main">
              {{this.titleResp}}
            </router-link>
            </span></div>
        </div>
        <div class="swiper-content position-relative p-md-0 py-3">
          <div class="swiper mySwiper" :class="{'swiper1': this.iconNum === 1 ,
     'swiper2': this.iconNum === 2}">
            <div class="swiper-wrapper">
              <div v-for="image in images" :key="image.id" class="swiper-slide">
                <div class="slide-img"><img :src="image.image.url" alt=""></div>
            
              </div>
            </div>
          </div>
          <div class="swiper-button-next" :class="{'next1': this.iconNum === 1 ,
     'next2': this.iconNum === 2}">
            <svg class="icon" width="35" height="35" stroke="#fff"><use href="@/assets/svgIcons/svgIcons.svg/#arrow-right-circle"></use></svg>
          </div>
          <div class="swiper-button-prev" :class="{'prev1': this.iconNum === 1 ,
     'prev2': this.iconNum === 2}">
            <svg class="icon" width="35" height="35" stroke="#fff"><use href="@/assets/svgIcons/svgIcons.svg/#arrow-left-circle"></use></svg>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min'
export default {
  name: "PhotosSlider",
  props:{
    images:Array,
    title:{
      type:String,
      default:''
    },
    titleResp:{
      type:String,
      default:''
    },
    iconNum:{
      type:Number,
      default: 1
    }
  },
  data(){
    return{
      iconSvg:this.iconNum
    }
  },
  components:{

  },
  mounted() {
    // if(window.innerWidth > 992){
    //   document.querySelector('.photos-slider-content').style.height = document.querySelector('.swiper-slide').offsetWidth + 64 + 'px';

    // }else if(window.innerWidth <= 992 && window.innerWidth > 767 ){
    if(window.innerWidth <= 992 && window.innerWidth > 767 ){
      document.querySelectorAll('.photos-slider-content').forEach(item=>{
        item.style.height = document.querySelector('.swiper-slide').offsetWidth + 32 + 'px';
      })

    }else if(window.innerWidth <= 767 ){
      document.querySelectorAll('.swiper-content').forEach(item=>{
        item.style.height = document.querySelector('.swiper-slide').offsetWidth + 32 + 'px';
      })

    }
    new Swiper(".swiper1", {
      spaceBetween: 20,
      loop:true,
      navigation: {
        nextEl: ".next1",
        prevEl: ".prev1",
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        600: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        992: {

          slidesPerView: 3,
          spaceBetween: 32,
        },
      },

    });



  }
}
</script>

<style scoped>
.photos-slider-grid{
  display: grid;
  grid-template-columns:minmax(100px , 2fr) minmax(100px , 5fr);
  padding-bottom: 4rem;
}
.photos-slider-grid2{
  display: grid;
  grid-template-columns:minmax(100px , 5fr) minmax(100px , 2fr);
}
.photos-slider-grid .photos-slider-head{
  order: 0;
}
.photos-slider-grid2 .photos-slider-head{
  order: 1;
}
.photos-slider-content{
  box-shadow: 0 0 5px #0003;
  position: relative;
  padding: 2rem 3rem;
  background-color: white;
  transform: translateY(-2.5rem);
}
.photos-slider-grid .photos-slider-content{
  border-radius:0 30px 30px 0;
}
.photos-slider-grid2 .photos-slider-content{
  border-radius: 30px  0 0 30px;
}
.photos-slider-head button{
  background: no-repeat;
  position: relative;
}
.photos-slider-grid .photos-slider-head a{
  color: var(--color-theme);
}
.photos-slider-grid2 .photos-slider-head a{
  color: white;
}
.photos-slider-grid h6{
  color: var(--color-theme);
}
.photos-slider-grid2 h6{
  color: white;
}
.photos-slider-grid .photos-slider-head a:after{
  background-color: var(--color-theme);
}
.photos-slider-grid2 .photos-slider-head a:after{
  background-color: white;
}
.photos-slider-head button:after{
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.photos-slider-head a:hover{
  transform: translateY(-2px);
}

.photos-slider-content .swiper-slide{
  border-radius: 30px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  max-height: 100%;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after , .swiper-button-prev::after, .swiper-rtl .swiper-button-next::after {
  content: '';
}
.swiper-button-next, .swiper-button-prev {
  width: unset;
}
.swiper-button-next, .swiper-rtl .swiper-button-prev{
  right: -40px;
}
.swiper-button-prev, .swiper-rtl .swiper-button-next{
  left: -40px;
}
.swiper-button-next svg, .swiper-button-prev svg{
  fill: #8a8a8a ;
  opacity: .3;
}
.swiper-button-next svg:hover, .swiper-button-prev svg:hover{
  fill: #333 !important;
}
.slide-img{
  width: 100%;
  height: 100%;
  border-radius: 30px;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
  height: 100%;
}
.slide-svg{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50% , -50%);
  /*z-index: 2;*/
  width: 30%;
  height: 30%;
}
.slide-svg:hover svg{
  transform: scale(1.05);
}
@media screen and (max-width: 991px){
  .photos-slider-content {
    padding: 1rem 2rem;
  }
  .swiper-button-next, .swiper-rtl .swiper-button-prev{
    right: -29px;
  }
  .swiper-button-prev, .swiper-rtl .swiper-button-next{
    left: -29px;
  }
  .swiper-button-next svg , .swiper-button-prev svg {
    width: 25px !important;
    height: 25px !important;
  }
  .photos-slider-grid2 .photos-slider-head.mt-5{
    margin-top: 2rem !important;
  }
}
@media screen and (max-width: 767px) {
  .swiper-button-next, .swiper-rtl .swiper-button-prev{
    right: 5px;
  }
  .swiper-button-prev, .swiper-rtl .swiper-button-next{
    left: 5px;
  }
  .photos-slider-head{
    display: none;
  }
  .photos-slider-grid{
    padding-bottom: 2rem;
  }
  .photos-slider-grid .photos-slider-content{
    margin-right: 1.5rem;
    display: grid;
    grid-template-columns: minmax(50px , 1fr) minmax(50px , 4fr);
    background-color: var(--color-theme);
    box-shadow: -3px 3px 3px #0003 inset ;

  }
  .photos-slider-grid2 .photos-slider-content{
    margin-left: 1.5rem;
    display: grid;
    grid-template-columns: minmax(50px , 4fr) minmax(50px , 1fr);
    background-color: var(--color-theme2);
    box-shadow: 3px 3px 3px #0003 inset ;
  }
  .photos-slider-grid , .photos-slider-grid2{
    display: block;

  }
  .photos-slider-content {
    position: static;
    padding: 0;
  }
  .photos-slider-grid .photos-slider-content .swiper{
    padding-left: 3rem;
  }
  .photos-slider-grid2 .photos-slider-content .swiper{
    padding-right: 3rem;
  }
  .photos-slider-grid .head2{
    order: 0;
  }
  .photos-slider-grid2 .head2{
    order: 1;
  }
  .swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled {
    opacity: .1;
  }
  .photos-slider-grid .swiper-content {
    padding-right: 2.5rem;
  }
  .photos-slider-grid2 .swiper-content{
    padding-left: 2.5rem;
  }
  .swiper-button-next svg, .swiper-button-prev svg {
    fill: #fff;
  }
  .photos-slider-grid2 .swiper-button-next svg, .photos-slider-grid2 .swiper-button-prev svg {
    fill: var(--color-theme);
    stroke: var(--color-theme);
    opacity: .6;
  }
  .photos-slider>div{
    background-color: unset !important;
  }
}
@media screen and (max-width: 400px){
  .photos-slider-grid .photos-slider-content{
    grid-template-columns: minmax(50px , 1fr) minmax(50px , 3fr);
  }
  .photos-slider-grid2 .photos-slider-content{
    grid-template-columns: minmax(50px , 3fr) minmax(50px , 1fr);
  }
}
</style>